import * as Constants from './Constants';

const initialState = {
  tosEnable: '',
  isCartVisible: true,
  isSubmitSuccess: false,
  tosSignature: '',
  enableContinueBtn: false,
  isMobileTos: false,
  tosContent: null,
  showErrNotification: false,
  errNotificationMsg: '',
  pageLoadError: false,
  nbsVo: [],
  nbsError: '',
  nbsLoaded: false,
  nbsApiError: false,
  showPaymentSelectOnEditClick: false,
  showReviewOrderApiError: false,
  updateShippingAdressflag: false,
  updateShippingAdressResponse: {},
  isInvalidAddressError: false,
  isInvalidOTP: false,
  updateValidateOTPResponse: {},
  SubmitOrderAPItriggered: false,
  orderReviewServiceInfo: null,
  orderReviewError: false,
  orderReviewNtfyMsg: null,
  tosCheckBoxState: { terms: null, custAgree: null },
};

function termsAndConditions(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA_SUCCESS_GET_AGREEMENTS:
      return { ...state, data: action.response && action.response.data };
    case Constants.UPDATE_SHOW_CART: {
      return { ...state, isCartVisible: action.data };
    }
    case Constants.SUBMIT_SUCCESS: {
      const preState = state.isSubmitSuccess;
      if (action.flagToggle) {
        return { ...state, isSubmitSuccess: preState, orderSubmitResponse: action.response };
      }
      return { ...state, isSubmitSuccess: !preState };
    }
    // return { ...state, isSubmitSuccess: action.response };
    case Constants.VALIDATE_CART_SUCCESS:
      return { ...state, enableContinueBtn: true };
    case Constants.OPEN_TOS_MOBILE:
      return { ...state, isMobileTos: action.data.isMobileTos, tosContent: action.data.tosContent };
    case Constants.EDIT_PAYMENT_REVIEW_ORDER: {
      return { ...state, showPaymentSelectOnEditClick: true };
    }
    case 'RESET_PAYMENT_REVIEW_ORDER': {
      return { ...state, showPaymentSelectOnEditClick: false };
    }
    case 'BROWSER_REFRESH': {
      return { ...state, browserRefresh: action.response };
    }
    case 'NBS_RECEIVED_ORDER':
      return {
        ...state,
        nbsVo: action.response,
        nbsLoaded: true,
        nbsApiError: false,
      };
    case 'NBS_CALLED_ORDER':
      return { ...state, nbsOrderCalled: action.response };
    case Constants.ERR_OCCURED:
      return { ...state, showErrNotification: action.errorReview, orderReviewServiceInfo: action.servieinfo };
    case Constants.SHOW_REVIEWORDER_API_ERROR: {
      return { ...state, showReviewOrderApiError: action.errorReview, orderReviewServiceInfo: action.servieinfo };
    }
    case Constants.ORDER_FETCH_SMS_DEVICES_SUCCESS:
      return {
        ...state,
        securePinDataDeviceSucess: action.response,
        isInvalidOTP: false,
        ...action.commonData,
      };
    case Constants.ORDER_FETCH_SMS_DEVICES_ERROR:
      return { ...state, isInvalidOTP: true, updateValidateOTPResponse: action.response, orderReviewServiceInfo: action.servieinfo };
    case Constants.ORDERUPDATE_SHIPPING_ADDRESS_SUCCESS:
      return { ...state, updateShippingAdressResponse: action.response, isInvalidAddressError: false };
    case Constants.ORDERUPDATE_ADRESS_SUUCESS: {
      const preState = state.updateShippingAdressflag;
      return { ...state, updateShippingAdressflag: !preState };
    }
    case Constants.ORDER_GET_SEND_SMS_SUCCESS:
      return { ...state, getSmsSuccess: action.response };
    case Constants.ORDER_GET_DATA_SUCCESS:
      return { ...state, title: action.response && action.response.data };
    case Constants.ORDER_GET_ENABLED_DEVICES_SUCCESS:
      return { ...state, securePinData: action.response };
    case 'ORDER_CITY_AND_STATE_SUCCESS':
      return { ...state, marketDetails: action.response };
    case 'INVALID_ADDRESS': {
      return { ...state, isInvalidAddressError: true, updateShippingAdressResponse: action.response, orderReviewServiceInfo: action.servieinfo };
    }
    case 'CLEAR_INVALID_RESPONSE_FROM_OR':
      return { ...state, isInvalidAddressError: false };
    case 'CLEAR_INVALID_OTP_FROM_OR':
      return { ...state, isInvalidOTP: false };
    case 'ENABLE_BUTTON':
      return { ...state, tosEnable: action.data };
    case 'GET_SUBMIT_ORDER_API_TRIGGERED':
      return { ...state, SubmitOrderAPItriggered: action.data };
    case Constants.PROMOS_RESPONSE_RECEIVED: {
      return { ...state, promos: action.response.promo };
    }
    case Constants.CEF_REVIEW_ORDER_ERROR: {
      return { ...state, orderReviewError: action.response, orderReviewNtfyMsg: action.errorMessage };
    }
    case 'BUTTON_DISABLE':
      return { ...state, disableButton: action.response };
    case 'UPDATE_TOS_CHECKBOX_STATE': {
      return { ...state, tosCheckBoxState: action.response };
    }
    default:
      return state;
  }
}

export const tos = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_TOS_SIGNATURE': {
      return { ...state, tosSignature: action.response };
    }
    default:
      return state;
  }
};

export default termsAndConditions;
